var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmelaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3921_33636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 31,
    height: 31,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3921_33636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06569 5.67545C5.5477 5.64453 5.03816 5.81532 4.64722 6.15091C4.25628 6.48649 4.01537 6.9599 3.97656 7.46877V23.5355C4.01559 24.0443 4.25657 24.5176 4.64745 24.8531C5.03834 25.1887 5.54776 25.3595 6.06569 25.3289C6.58356 25.3593 7.09285 25.1884 7.48368 24.8529C7.87452 24.5174 8.11556 24.0442 8.15481 23.5355V7.46877C8.11578 6.95998 7.8748 6.48671 7.48392 6.15117C7.09303 5.81563 6.58361 5.64475 6.06569 5.67545Z",
    fill: "#FEA628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6594 5.67545C24.1415 5.64475 23.6321 5.81563 23.2412 6.15117C22.8503 6.48671 22.6093 6.95998 22.5703 7.46877V23.5355C22.6096 24.0442 22.8506 24.5174 23.2414 24.8529C23.6323 25.1884 24.1416 25.3593 24.6594 25.3289C25.1774 25.3595 25.6868 25.1887 26.0777 24.8531C26.4686 24.5176 26.7095 24.0443 26.7486 23.5355V7.46877C26.7098 6.9599 26.4688 6.48649 26.0779 6.15091C25.687 5.81532 25.1774 5.64453 24.6594 5.67545Z",
    fill: "#FEA628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3635 0.501654C14.834 0.480354 14.3173 0.665495 13.926 1.01681C13.5346 1.36812 13.3001 1.85718 13.2734 2.37763V28.6265C13.2998 29.1471 13.5342 29.6364 13.9257 29.9879C14.3171 30.3394 14.8338 30.5247 15.3635 30.5034C15.8928 30.5245 16.4092 30.3392 16.8004 29.9879C17.1916 29.6366 17.426 29.1477 17.4526 28.6274V2.37763C17.426 1.85734 17.1916 1.36841 16.8004 1.01712C16.4092 0.665832 15.8928 0.480589 15.3635 0.501654Z",
    fill: "#FEA628"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmelaLogo);
export default __webpack_public_path__ + "static/media/amela-logo.55efbd02d1f0863a8fc69c98946c7164.svg";
export { ForwardRef as ReactComponent };